import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { EnrollService, GlobalFunctionsService, PaymentService } from 'app/core/services';
import { Course, Order, Person } from 'app/shared/models';
import { environment } from 'environments/environment';
import * as moment from 'moment';

@Component({
  moduleId: module.id,
  selector: 'fo-confirm',
  templateUrl: './confirm.page.html'
})
export class ConfirmPage implements OnInit {
  order: Order;
  course: Course;
  conditionsUrl: string;
  conditionsAgreed: boolean;
  studentsList: Person[];
  isClickedOnce = false;
  studentCount = 0;
  issuer: string;
  paymentType = 'invoice';

  constructor(
    private globalFunctionsService: GlobalFunctionsService,
    private enrolService: EnrollService,
    private paymentService: PaymentService,
    private config: AppConfig,
    private router: Router
  ) {
    this.conditionsUrl = this.config.getConfig('termsUrl');
    this.globalFunctionsService.showBasket(false);
    this.globalFunctionsService.showTabs(true);
  }

  ngOnInit(): void {
    this.paymentType = environment.paymentType;
    this.order = this.globalFunctionsService.getOrder();
    this.course = this.globalFunctionsService.getSelectedCourse();
    this.issuer = this.globalFunctionsService.selectedIssuer;

    // Fill Students-List
    if (!this.studentsList) {
      this.studentsList = [];
    }
    if (this.order.FirstStudentIsContact) {
      // Create Student from Contact
      const student = new Person();
      student.FirstName = this.order.ContactPerson.FirstName;
      student.Initials = this.order.ContactPerson.Initials;
      student.Surname = this.order.ContactPerson.Surname;
      student.MiddleName = this.order.ContactPerson.MiddleName;
      student.Gender = this.order.ContactPerson.Gender;
      student.Email = this.order.ContactPerson.Email;
      student.Phone = this.order.ContactPerson.Phone;
      student.Mobile = this.order.ContactPerson.Mobile;
      student.Address = this.order.ContactPerson.Address;
      student.AddressNumber = this.order.ContactPerson.AddressNumber;
      student.PostalCode = this.order.ContactPerson.PostalCode;
      student.City = this.order.ContactPerson.City;
      student.CountryId = this.order.ContactPerson.CountryId;
      student.DateOfBirth = this.order.ContactPerson.DateOfBirth;
      student.PlaceOfBirth = this.order.ContactPerson.PlaceOfBirth;
      student.UserField1 = this.order.ContactPerson.UserField1;
      student.UserField2 = this.order.ContactPerson.UserField2;
      student.UserField3 = this.order.ContactPerson.UserField3;
      student.UserField4 = this.order.ContactPerson.UserField4;
      student.UserField5 = this.order.ContactPerson.UserField5;
      student.UserField6 = this.order.ContactPerson.UserField6;
      student.UserField7 = this.order.ContactPerson.UserField7;
      student.UserField8 = this.order.ContactPerson.UserField8;
      student.UserField9 = this.order.ContactPerson.UserField9;
      student.EnrolmentUserField1 = this.order.ContactPerson.EnrolmentUserField1;

      // Add Contact to Students Array
      this.studentsList.push(student);
    }

    for (const s of this.order.Students) {
      this.studentsList.push(s);
    }

    this.studentCount = this.studentsList.length;
  }

  previousTab(): void {
    // Redirect
    // TODO: Animate
    window.scrollTo(0, 0);
    this.router.navigate(['payment'], { queryParamsHandling: 'merge' });
  }

  saveInfo(isValid: boolean): void {
    if (isValid && !this.isClickedOnce) {
      this.isClickedOnce = true;

      try {
        // Create Correct Order-Message
        if (this.order.FirstStudentIsContact) {
          // Create Student from Contact
          const student = new Person();
          student.FirstName = this.order.ContactPerson.FirstName;
          student.Initials = this.order.ContactPerson.Initials;
          student.Surname = this.order.ContactPerson.Surname;
          student.MiddleName = this.order.ContactPerson.MiddleName;
          student.Gender = this.order.ContactPerson.Gender;
          student.Email = this.order.ContactPerson.Email;
          student.Phone = this.order.ContactPerson.Phone;
          student.Mobile = this.order.ContactPerson.Mobile;
          student.Address = this.order.ContactPerson.Address;
          student.AddressNumber = this.order.ContactPerson.AddressNumber;
          student.PostalCode = this.order.ContactPerson.PostalCode;
          student.City = this.order.ContactPerson.City;
          student.CountryId = this.order.ContactPerson.CountryId;
          student.DateOfBirth = this.order.ContactPerson.DateOfBirth;
          student.PlaceOfBirth = this.order.ContactPerson.PlaceOfBirth;
          student.Iban = this.order.ContactPerson.Iban;
          student.UserField1 = this.order.ContactPerson.UserField1;
          student.UserField2 = this.order.ContactPerson.UserField2;
          student.UserField3 = this.order.ContactPerson.UserField3;
          student.UserField4 = this.order.ContactPerson.UserField4;
          student.UserField5 = this.order.ContactPerson.UserField5;
          student.UserField6 = this.order.ContactPerson.UserField6;
          student.UserField7 = this.order.ContactPerson.UserField7;
          student.UserField8 = this.order.ContactPerson.UserField8;
          student.UserField9 = this.order.ContactPerson.UserField9;
          student.EnrolmentUserField1 = this.order.ContactPerson.EnrolmentUserField1;

          // Add Contact to Students Array
          if (!this.order.Students) {
            this.order.Students = [];
          }
          this.order.Students.splice(0, 0, student);
        }

        // Set Course for Students
        this.order.Students.forEach(student => {
          student.CourseId = this.course.Id;
        });

        // Set price category for students
        if (this.order.PaymentTerms === '3') {
          this.order.Students.forEach(student => {
            student.PriceCategory = 'Termijnbetaling';
          });
        }

        // Create Copy for clean-up purpose
        const copiedOrder = { ...this.order };
        copiedOrder.UserField1 = this.order.UserField1;
        copiedOrder.UserField2 = this.order.UserField2;
        copiedOrder.UserField3 = this.order.UserField3;
        copiedOrder.ContactPerson.Iban = this.order.ContactPerson.Iban;

        // Create Correct Order-Message
        if (!copiedOrder.Company.Name) {
          // Clear Company
          copiedOrder.Company = null;
        } else {
          // Copy Address to Company
          copiedOrder.Company.PostalCode = this.order.ContactPerson.PostalCode;
          copiedOrder.Company.AddressNumber = this.order.ContactPerson.AddressNumber;
          copiedOrder.Company.Address = this.order.ContactPerson.Address;
          copiedOrder.Company.City = this.order.ContactPerson.City;
          copiedOrder.Company.CountryId = this.order.ContactPerson.CountryId;
          // Clear ContactPerson Address
          copiedOrder.ContactPerson.PostalCode = null;
          copiedOrder.ContactPerson.AddressNumber = null;
          copiedOrder.ContactPerson.Address = null;
          copiedOrder.ContactPerson.City = null;
          copiedOrder.ContactPerson.CountryId = 'NL';
        }
        if (!copiedOrder.InvoiceCompany.Name) {
          // Clear Invoice Company
          copiedOrder.InvoiceCompany = null;
        } else {
          // Copy Address to Invoice Company
          copiedOrder.InvoiceCompany.Address = this.order.InvoicePerson.Address;
          copiedOrder.InvoiceCompany.AddressNumber = this.order.InvoicePerson.AddressNumber;
          copiedOrder.InvoiceCompany.PostalCode = this.order.InvoicePerson.PostalCode;
          copiedOrder.InvoiceCompany.City = this.order.InvoicePerson.City;
          copiedOrder.InvoiceCompany.CountryId = this.order.InvoicePerson.CountryId;
          // Clear InvoicePerson Address
          copiedOrder.InvoicePerson.Address = null;
          copiedOrder.InvoicePerson.AddressNumber = null;
          copiedOrder.InvoicePerson.PostalCode = null;
          copiedOrder.InvoicePerson.City = null;
          copiedOrder.InvoicePerson.CountryId = 'NL';
        }
        if (!copiedOrder.InvoicePerson.Surname) {
          // Clear Invoice Person
          copiedOrder.InvoicePerson = null;
        }

        const amount = this.course.Price * this.studentCount;
        const timestamp = moment().format('X');
        const invoiceReference = `vip_${timestamp}`;
        copiedOrder.InvoiceReference = invoiceReference;

        console.log(copiedOrder);

        // Save order
        this.enrolService
          .create(copiedOrder)
          .then(() => {
            this.globalFunctionsService.updateOrder(copiedOrder);
            this.globalFunctionsService.enableTabs(4);
            window.scrollTo(0, 0);
            if (this.paymentType === 'ideal') {
              this.paymentService.requestTransaction(amount, invoiceReference, this.issuer);
            } else {
              this.router.navigate(['thanks'], { queryParamsHandling: 'merge' });
            }
          })
          .catch(() => {
            this.globalFunctionsService.enableTabs(4);
            window.scrollTo(0, 0);
            this.router.navigate(['error'], { queryParamsHandling: 'merge' });
          });
      } catch (error) {
        this.globalFunctionsService.enableTabs(4);
        window.scrollTo(0, 0);
        this.router.navigate(['error'], { queryParamsHandling: 'merge' });
      }
    }
  }

  createFullName(gender: string, initials: string, middleName: string, surname: string, includeTav: boolean): string {
    let fullName = includeTav ? 'T.a.v. ' : '';

    if (gender) {
      if (gender === 'M') {
        fullName += includeTav ? 'de heer ' : 'De heer ';
      } else {
        fullName += includeTav ? 'mevrouw ' : 'Mevrouw ';
      }
    }

    if (initials) {
      fullName += initials + ' ';
    }

    if (middleName) {
      fullName += middleName + ' ';
    }

    if (surname) {
      fullName += surname;
    }

    return fullName;
  }
}
